export default __webpack_public_path__ + "static/media/rockwell automation.45b05023.png";